import React, { useEffect, useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  Liststock,
  StocksbyOrganisation,
  findArticleRefParentApi,
  findStockByArticle_codeApi,
} from "../../_App/Redux/Slices/article/articleSlice";
import {
  SelectedOrganisationId,
  SelectedOrganisations,
  selectUser,
  selectUserId,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { handleKeyPress_number } from "../../_App/Helpers/helpers";
import { number, string } from "yup";
import { createTransfertApi } from "../../_App/Redux/Slices/transferArticle/transferArticleSlice";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import {
  DepotDefautOrganisation,
  findDepotsDefautByOrganisationApi,
} from "../../_App/Redux/Slices/depot/depotSlice";
import ArticleListReference from "../../_Layouts/RightBar/RightBar/cart/ArticleListReference";

export default function DemandeTransfert({ ShowModal, setShowModal }: any) {
  type interfacedata = {
    QuantiteTotal: number;
    organisation_transfer: string;
    organisation_demande?: string;
    depots_reception?: string;
    depots_id: any;
    societe_id: string;
    lignes: any[];

    user_id: string;
  };
  type LignesType = {
    article_id: String;
    Quantite: number;
    stock: String;
  };
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const dispatch = useAppDispatch();
  const list_stock = useAppSelector(StocksbyOrganisation);
  const list_organisation = useAppSelector(SelectedOrganisations);
  const selectedOrganisationId = useAppSelector(SelectedOrganisationId);
  const user = useAppSelector(selectUserId);
  const [loadingsearch, setloadingsearch] = useState(false);
  const societeid = useAppSelector(societeId);
  const [ListReference, setListReference] = useState<any[]>();
  const [ShowModalListReference, setShowModalListReference] = useState(false);

  const depotdefaut = useAppSelector(DepotDefautOrganisation);
  const userinfo = useAppSelector(selectUser);
  const [TypeInput, setTypeInput] = useState("codeBarre");

  const [StockKeys, setStockKeys] = useState<string[]>([]);
  const [choisi, setchoisi] = useState<interfacedata[]>([]);

  const getlist = async (value: string) => {
    if (value !== "") {
      await dispatch(findStockByArticle_codeApi({search:value ,societe:societeid}));
    }
  };
  const selectItem = async (item: any) => {
    await getlist(item.article.code_a_barre[0]);
    setShowModalListReference(false);
  };

  useEffect(() => {
    if (userinfo?.role_id?.libelle) {
      dispatch(findDepotsDefautByOrganisationApi("null"));
    } else {
      if (selectedOrganisationId)
        dispatch(findDepotsDefautByOrganisationApi(selectedOrganisationId));
    }
  }, [selectedOrganisationId]);

  useEffect(() => {
    setStockKeys(Object.keys(list_stock));
  }, [list_stock]);

  useEffect(() => {
    setStockKeys(Object.keys(list_stock));
    let total = 0;
    for (const key in list_stock) {
      if (list_stock.hasOwnProperty(key)) {
        total += list_stock[key].reduce(
          (acc: number, stock: any) => acc + stock.stock,
          0
        );
      }
    }
  }, [list_stock]);
  const handelcheck = (stock: any, organisation_id: string) => {
    // data {stock_id : ,Quantite: }
    // check if checked
    const checkindex = checkedItem(organisation_id, stock);
    if (checkindex !== -1) {
      // deleted from list
      const newlist = [...choisi];
      newlist.splice(checkindex, 1);
      setchoisi(newlist);
    } else {
      // add to list
      if (list_stock[organisation_id]) {
        const findstock = list_stock[organisation_id]?.find(
          (stock: any) => stock._id === stock._id
        );

        const demandeOrgInd = choisi.findIndex(
          (c: any) =>
            c.organisation_transfer === organisation_id &&
            c.depots_id._id === findstock.depots_id._id
        );

        if (demandeOrgInd !== -1) {
          // Faire une copie profonde de l'élément modifié
          setchoisi((prev) => {
            const newChoisi = [...prev]; // copie du tableau
            newChoisi[demandeOrgInd] = {
              ...newChoisi[demandeOrgInd], // copie de l'objet
              lignes: [
                ...newChoisi[demandeOrgInd].lignes,
                {
                  article_id: findstock.article_id,
                  article: findstock.article,
                  Quantite: "",
                  stock: stock._id,
                },
              ],
            };
            return newChoisi;
          });
        } else {
          const data: interfacedata = {
            user_id: user || "",
            organisation_transfer: organisation_id,
            organisation_demande: selectedOrganisationId,
            depots_id: findstock.depots_id,
            depots_reception: depotdefaut?._id,
            lignes: [
              {
                article_id: findstock.article_id,
                article: findstock.article,
                Quantite: "",
                stock: stock._id,
              },
            ],
            societe_id: findstock.societe_id,
            QuantiteTotal: findstock.stock,
          };
          setchoisi((prev) => [...prev, data]);
        }
      }
    }
  };
  const handelinputchange = (org: string, stock: any, qte: number) => {
    const checkindex = checkedItem(org, stock);

    if (checkindex !== -1) {
      setchoisi((prev) => {
        const newChoisi = [...prev];
        const lignes = newChoisi[checkindex].lignes.map((ligne) => {
          if (ligne.stock === stock._id) {
            return { ...ligne, Quantite: qte || "" };
          }
          return ligne;
        });

        newChoisi[checkindex] = {
          ...newChoisi[checkindex],
          lignes,
        };

        return newChoisi;
      });
    }
  };

  const demander = async () => {
    if (choisi.length !== 0) {
      const updatedList = choisi
        .map((i) => {
          return {
            ...i,
            depots_id: i.depots_id?._id || i.depots_id, // sécurité si déjà _id
            lignes: i.lignes.filter(
              (l) => l.Quantite !== 0 && l.Quantite !== "" && l.Quantite != null
            ),
          };
        })
        .filter((i) => i.lignes.length > 0);
      const response = await dispatch(createTransfertApi(updatedList));
      if (response?.payload.success) {
        ToastSuccess(response?.payload.message);
        setShowModal(false);
      } else {
        ToastWarning(response?.payload.message);
      }
    } else {
      ToastWarning(t("Aucun dépôt sélectionné"));
    }
  };
  const lastKeyPressTime = useRef<number>(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handelScan = (cleanedValue: any) => {
    setSearchTerm(cleanedValue);
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;
    // Si le temps entre deux entrées est court, c'est probablement un scan
    const isScannerInput = timeDiff < 50;
    //117065alert(isScannerInput)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(
      async () => {
        if (cleanedValue !== "" || isScannerInput) {
          await handleInputChange(cleanedValue);
        }
      },
      isScannerInput ? 100 : 2000
    );
  };

  const handleInputChange = async (inputValue: string) => {
    setloadingsearch(true);

    if (TypeInput === "codeBarre") {
      await getlist(inputValue);
    } else {
      const resultReference = await dispatch(
        findArticleRefParentApi({ ref: inputValue, societe_id: societeid })
      );

      // const resultBon = await dispatch(findBonByBarcode(inputValue));
      if (resultReference.payload) {
        const list = resultReference?.payload?.map((e: any) => {
          return { article: e };
        });
        setListReference(list);
        setShowModalListReference(true);
      } else {
        ToastWarning(t("Ce code n'est associé à aucun article "));
        setSearchTerm("");
      }
    }

    setloadingsearch(false);
  };
  const checkedItem = (key: string, stock: any) => {
    const checked = choisi?.findIndex(
      (c: any) =>
        c.organisation_transfer === key &&
        c.depots_id._id === stock.depots_id._id &&
        c.lignes.find((l: any) => l.article_id === stock.article_id)
    );
    return checked;
  };
  const firstKey = Object.keys(list_stock)[0];

  return (
    <div>
      <Modal
        show={ShowModal}
        onHide={() => setShowModal(false)}
        className="modal-2"
        dialogClassName="modal-40w"
        backdropClassName="modal-backdrop-2"
      >
        <Modal.Header closeButton>
          <Modal.Title className="c-primary">
            {t("Demande Transfert")}{" "}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="col-md-6   ">
              <div className="form-group">
                <label htmlFor="article">{t("Article ")}</label>
                <div className="search-bar" style={{ position: "relative" }}>
                  <input
                    type="text"
                    className={"form-control search-form-control ml-lg-auto"}
                    autoFocus={true}
                    onChange={(e) => {
                      // Nettoyer la valeur : éliminer les retours à la ligne et les espaces inutiles
                      const cleaned = e.target.value.replace(/\n/g, "").trim();

                      handelScan(cleaned);
                    }}
                    value={searchTerm}
                    placeholder={t("Enter code a barre ou bien ref ")}
                    id="code_input"
                    style={{
                      height: "40px",
                      paddingRight: "2.5rem",
                    }}
                  />

                  {loadingsearch ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Spinner animation="border" role="status" size="sm">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {TypeInput === "codeBarre" ? (
                        <button
                          className="btn  btn-primary-app pointer"
                          onClick={() => setTypeInput("ref")}
                          style={{
                            position: "absolute",
                            right: "-10px",
                            top: "-19px",
                          }}
                        >
                          CB
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary-app pointer"
                          onClick={() => setTypeInput("codeBarre")}
                          style={{
                            position: "absolute",
                            right: "-10px",
                            top: "-19px",
                          }}
                        >
                          REF
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {list_stock && (
            <h5 className="mt-4 fw-bold">
              {t("Article")}{" "}
              {list_stock[firstKey]?.[0]?.article?.titre?.fr || ""}
            </h5>
          )}
          <div className="table-responsive">
            {StockKeys && StockKeys.length > 0 ? (
              <>
                <table className="table   ">
                  <thead>
                    <tr></tr>
                    <tr>
                      <th></th>
                      <th>{t("Depots")}</th>
                      <th>{t("Quantite")}</th>
                      <th colSpan={2}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {StockKeys.map(
                      (key) =>
                        selectedOrganisationId !== undefined &&
                        key !== selectedOrganisationId && (
                          <React.Fragment key={key}>
                            <tr>
                              <td colSpan={4} className="highlighted-row">
                                {t("Organisation")}{" "}
                                {list_organisation?.find(
                                  (item: any) => item._id === key
                                )?.nom || "Societe"}
                              </td>
                            </tr>

                            {list_stock[key] &&
                              list_stock[key].map((stock: any) => (
                                <tr key={stock._id}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={checkedItem(key, stock) !== -1}
                                      onClick={() => handelcheck(stock, key)}
                                    />
                                  </td>
                                  <td>
                                    {stock.depots_id?.libelle || "undefined"}
                                  </td>

                                  <td>{stock.stock}</td>
                                  {checkedItem(key, stock) !== -1 ? (
                                    <td>
                                      <input
                                        type="text"
                                        onKeyPress={handleKeyPress_number}
                                        value={
                                          choisi[
                                            checkedItem(key, stock)
                                          ].lignes.find(
                                            (l) =>
                                              l.article_id === stock.article_id
                                          ).Quantite
                                        }
                                        onChange={(e) =>
                                          handelinputchange(
                                            key,
                                            stock,
                                            parseInt(e.target.value)
                                          )
                                        }
                                      />
                                    </td>
                                  ) : null}
                                </tr>
                              ))}
                          </React.Fragment>
                        )
                    )}
                  </tbody>
                </table>
                <button
                  className="btn btn-primary-app"
                  onClick={() => {
                    setSearchTerm("");
                    setStockKeys([]);
                  }}
                >
                  {t("Ajouter autre article")}
                </button>
              </>
            ) : null}
          </div>
          {/* 🔹 Liste récapitulative des articles choisis */}
          {choisi.length > 0 && (
            <>
              <h5 className="mt-4 fw-bold">{t("Liste à demander")}</h5>
              <div className="table-responsive mt-3">
                {choisi.map((demande, i) => {
                  return (
                    <div
                      key={i}
                      className="mb-4 border rounded-3 p-3 shadow-sm"
                    >
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                          <tr>
                            <td colSpan={4} className="highlighted-row">
                              {t("Organisation")}{" "}
                              {list_organisation?.find(
                                (item: any) =>
                                  item._id === demande.organisation_transfer
                              )?.nom || "Societe"}{" "}
                              - {t("Depots")} {demande.depots_id?.libelle}
                            </td>
                          </tr>
                          <tr>
                            <th>{t("Article ")}</th>
                            <th>{t("Quantité demandée")}</th>
                            <th className="text-center">{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {demande.lignes.map((ligne, j) => (
                            <tr key={j}>
                              <td>{ligne.article?.titre?.fr}</td>
                              <td>{ligne.Quantite}</td>
                              <td className="text-center">
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => {
                                    // 🔸 Supprimer cette ligne spécifique
                                    setchoisi((prev) => {
                                      const newChoisi = [...prev];
                                      const lignes = newChoisi[i].lignes.filter(
                                        (_, idx) => idx !== j
                                      );

                                      // Si plus aucune ligne => supprimer tout le groupe
                                      if (lignes.length === 0) {
                                        newChoisi.splice(i, 1);
                                      } else {
                                        newChoisi[i] = {
                                          ...newChoisi[i],
                                          lignes,
                                        };
                                      }
                                      return newChoisi;
                                    });
                                  }}
                                >
                                  ❌
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {choisi && choisi.length > 0 && (
            <button className="btn btn-primary-app" onClick={demander}>
              {t("Demander")}
            </button>
          )}
        </Modal.Footer>
      </Modal>
      <ArticleListReference
        t={t}
        ShowModal={ShowModalListReference}
        setShowModal={setShowModalListReference}
        selectAricle={selectItem}
        list={ListReference}
        reference={searchTerm}
      />
    </div>
  );
}
